import React from "react";
import { inject, observer } from "mobx-react";
import { Button, Card, Icon, Input, Layout, PageHeader, Pagination, Popconfirm, Select, Spin, Table } from "antd";
import StartMessagePopup from "./MessageListPopup";
import { startCar } from '@services/api'
import AddOrEditStartAgentPopup from "./AddOrEditStartAgentPopup";

@inject((store) => {
    const { authStore } = store
    return { authStore }
})
@observer
class StartAgents extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            list: [],
            editAgentPopup: '',
            messagePopup: '',
            addAgentPopup : false,

            page: 1,
            perPage: 10,
            total: 0,
            lastPage: 1,

            loadingDelete: '',

            searchBy: 'phone',
            searchValue: ''
        }
    }

    componentDidMount() {
        this.getAgents()
    }

    getAgents = (search?: object) => {
        const { page, perPage } = this.state
        startCar.getStartAgents({ page, perPage, ...search })
        .then((res) => {
            const { data, page, perPage, total, lastPage } = res.data.agents
            this.setState({ list: data, page, perPage, total, lastPage })
        })
        .catch((error) => {
            console.log('error', error.response);
        })
    }

    deleteAgent = (record) => {
        this.setState({ loadingDelete: record.id }, () => {
            startCar.deleteStartAgent({ id: record.id })
            .then((res) => {
                // console.log('res delete agent', res);
                this.getAgents()
            })
            .catch((error) => {
                console.log('error delete agent', error.response);
            })
            .finally(() => {
                this.setState({ loadingDelete: '' })
            })
        })
    }

    paginate= (page, perPage) => {
        this.setState({ page, perPage }, this.getAgents)
    }

    handleSearchInput = (e) => {
        let { value } = e.target
        const { searchBy } = this.state

        if (searchBy == 'phone') {
            value = value.replace(/\D/g, '')
        }
        this.setState({ searchValue: value })
    }

    search = () => {
        let { searchBy, searchValue } = this.state
        if (searchBy == 'phone') searchValue = searchValue.replace(/^0/, '')
        this.getAgents({ search: { [searchBy]: searchValue } })
    }

    resetSearch = () => {
        this.setState({ searchBy: 'phone', searchValue: '' }, this.getAgents)
    }

    columns = [
        {
            title: 'שם',
            key: 'name',
            align: 'right',
            render: (_, record) => <span>{`${record.name}`}</span>
        },
        {
            title: 'נייד',
            key: 'phone',
            align: 'right',
            render: (_, record) => <span>{record.phone ? `0${record.phone}` : ''}</span>
        },
        {
            title: 'אימייל',
            key: 'email',
            align: 'right',
            render: (_, record) => {
                const emails = JSON.parse(record.email)

                return (emails && emails.length) ? (
                    <div style={{ ...styles.emailCell }}>
                        {emails.map((e, idx) => <span key={idx.toString()} style={{ ...styles.emailLine }}>{e}</span>)}
                    </div>
                ) : ''
            }
        },
        {
            title: '',
            key: 'messages',
            align: 'right',
            render: (_, record) => {
                return (
                    <Button
                        onClick={() => {
                            this.setState({ messagePopup: record })                            
                        }}
                    >
                        {"צפייה בהודעות"}
                    </Button>
                )
            }
        },

    ]

    adminColumns = [
        {
            title: '',
            key: 'edit',
            align: 'right',
            render: (_, record) => {
                return (
                    <Button
                        onClick={() => this.setState({ editAgentPopup: record })}
                    >
                        {"עריכה"}
                    </Button>
                )
            }
        },
        {
            title: '',
            key: 'delete',
            align: 'right',
            render: (_, record) => {
                const { loadingDelete } = this.state
                return (
                    <Popconfirm
                        onConfirm={() => this.deleteAgent(record)}
                        title="האם למחוק את הסוכן?"
                        okText="כן"
                        cancelText="לא"
                    >
                        <Button>
                            <Icon type="delete" />
                        </Button>
                        {loadingDelete == record.id ? <Spin /> : <div style={{ display: 'inline-block', width: '20px' }}></div>}
                    </Popconfirm>
                )
            }
        }
    ]

    render() {

        const {
            list,
            messagePopup,
            addAgentPopup,
            editAgentPopup,
            searchBy,
            searchValue,
            total
        } = this.state
        const { authStore: { roles } } = this.props

        let tableColumns = [ ...this.columns ]

        if (roles.includes('admin') || roles.includes('start_manager')) {
            tableColumns = [ ...this.columns, ...this.adminColumns ]
        }

        return (
            <>
                <Layout>
                    <PageHeader
                        onBack={() => window.history.back()}
                        title={"סוכני start"}
                    />

                    <Card
                        title={
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>


                                <div style={{ ...styles.searchWrapper }}>
                                    <div style={{display: 'flex', alignItems: 'stretch'}}>
                                        <span style={{lineHeight: '1.8', marginLeft: '30px'}}>{"חיפוש לפי:"}</span>
                                        <Select
                                            id="type"
                                            style={{ width: '150px' }}
                                            defaultValue={searchBy}
                                            value={searchBy}
                                            onChange={(value) => this.setState({ searchBy: value, searchValue: '' })}
                                            >
                                            <Select.Option value={'phone'}>{'נייד'}</Select.Option>
                                            <Select.Option value={'name'}>{'שם'}</Select.Option>
                                        </Select>
                                    </div>
                                    <Input value={searchValue} onChange={this.handleSearchInput}/>
                                    <Button style={{ height: '32px' }} onClick={this.search}>{"חיפוש"}</Button>
                                    <Button style={{ marginRight: '60px' }} onClick={this.resetSearch}>{"איפוס"}</Button>

                                </div>


                               {(roles.includes('admin') || roles.includes('start_manager')) ? 
                                <Button
                                    onClick={() => this.setState({ addAgentPopup: true })}
                                    style={{ marginRight: 'auto', height: '32px' }}
                                >
                                    {"הוספת סוכן"}
                                </Button> : ''}
                            </div>
                        }
                        headStyle={{ backgroundColor: '#dadce0' }}
                        bodyStyle={{ padding: '0.8rem 0.8rem' }}
                        style={{ marginBottom: '1rem' }}
                    >

                        <Table
                            columns={tableColumns}
                            dataSource={list}
                            pagination={false}
                        />

                        <Pagination
                            style={{ marginTop: '20px' }}
                            size="small"
                            total={total}
                            onChange={(page, perPage) => this.paginate(page, perPage)}
                            onShowSizeChange={(page, perPage) => this.paginate(page, perPage)}
                            showSizeChanger
                        />

                    </Card>
                </Layout>
                {(addAgentPopup || editAgentPopup) ? 
                    <AddOrEditStartAgentPopup getAgents={this.getAgents} editAgent={editAgentPopup} close={() => this.setState({ editAgentPopup: '', addAgentPopup: false })} /> : ''}
                {messagePopup ?
                    <StartMessagePopup agent={messagePopup}  close={() => this.setState({ messagePopup: '' })} /> : ''}
            </>
        )
    }
}

const styles = {
    emailCell: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        maxHeight: '68px',
        overflowY: 'auto'
    },
    emailLine: {
        padding: '3px'
    },
    searchWrapper: {
        display: 'flex'
    }
}

export default StartAgents